/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type SearchedClientAnalysisState = (typeof SearchedClientAnalysisState)[keyof typeof SearchedClientAnalysisState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchedClientAnalysisState = {
  in_progress: "in_progress",
  completed: "completed",
  declined: "declined",
} as const;
